import { render } from "./SidenavLink.vue?vue&type=template&id=3fc76cbc"
import script from "./SidenavLink.vue?vue&type=script&lang=js"
export * from "./SidenavLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__